/**
 * src/setup-globals.ts — runtime globals for legacy compat.
 *
 * MUST be the first import in src/main.tsx (and any other entry point). ES
 * module loading semantics: imports are evaluated in source order, fully,
 * before any importer's body code runs. By splitting these assignments into
 * their own module and importing it FIRST, we guarantee window.Zod (etc.)
 * is set before src/lib/model.ts's IIFE reads it.
 *
 * Why this matters: src/lib/model.ts (the ported legacy model) does
 *   const z = window.Zod && window.Zod.z || null;
 * at module-load. If we set window.Zod inside main.tsx's body (post-imports),
 * it runs AFTER model.ts has already evaluated — the schema engine silently
 * disables itself ("[fonio] Zod did not load — boundary validation disabled").
 * This module fixes that ordering.
 */
import * as zod from "zod";

if (typeof window !== "undefined") {
  // Zod — legacy `src/lib/model.ts` reads window.Zod.z at module load to
  // build its Zod schemas. Phase 5 moves it to a proper ESM import.
  (window as any).Zod ??= { z: zod.z };
}
